import React, { ReactNode, useEffect } from 'react';
import styled from 'styled-components';

import { VIEW_TYPES } from '../../organisms/navigation/shared/constants';

import mq from '../../../styles/breakpoints';

interface Props {
  show: boolean;
  children: ReactNode;
  onRequestClose: () => void;
  viewType?: string;
}

const DropShadow = ({ show, children, onRequestClose, viewType }: Props) => {
  const handleKeyPress = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      onRequestClose();
    }
  };

  const handleScroll = () => {
    if (show) {
      window.scroll(0, 0);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    document.addEventListener('scroll', handleScroll);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      document.removeEventListener('scroll', handleScroll);
    };
  }, [show]);

  return (
    <Container>
      {children}
      {show && viewType === VIEW_TYPES.desktop && (
        <ModalContentWrapper onClick={onRequestClose} />
      )}
    </Container>
  );
};

export default DropShadow;

const Container = styled.div`
  position: relative;
`;

const ModalContentWrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.8);
  height: calc(100vh - 112px);
  left: 0;
  position: absolute;
  width: 100%;
  z-index: 5;

  ${mq.from.breakpoint.L`
    height: 100vh;
  `}
`;
